import { useState } from 'react';
import styled, { css } from 'styled-components';
import { Language as LanguageIcon } from '@mui/icons-material';
import { CountryCode } from 'libphonenumber-js';
import { CustomHeaderSelect } from './Select';
import { languageOptions } from '../../const';
import { Button, IconButton } from '../button';
import { FlagIcon } from '../input';
import { changeLanguage } from '../../i18n';
import { Typography } from '../typography';

const SelectWrapper = styled.div<{ position?: 'absolute' }>`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 0.4rem;
  align-items: center;

  ${(props) =>
    props.position === 'absolute' &&
    css`
      position: absolute;
      right: var(--spacing-5);
      top: var(--spacing-5);
    `}
`;

const LanguageSelectBase = styled(CustomHeaderSelect)`
  & + button {
    box-shadow: none !important;
    height: 3rem;
    padding: 0.7rem 1rem;

    & > .MuiButton-startIcon {
      margin-right: 0.7rem !important;
      margin-left: 0 !important;
    }
  }
`;

const FlagOptionWrapper = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-column-gap: 1rem;
  align-items: center;
`;

interface LanguageSelectProps {
  isButtonVariant?: boolean;
  withText?: boolean;
  position?: 'absolute';
  color?: 'white' | 'gray';
}

export const LanguageSelect = ({
  isButtonVariant,
  withText,
  position,
  color = 'gray',
}: LanguageSelectProps) => {
  const [openLanguage, setOpenLanguage] = useState(false);
  const languageText =
    languageOptions
      .find((item) => item.value === localStorage.getItem('lang'))
      ?.value.toUpperCase() || 'EN';

  if (isButtonVariant)
    return (
      <LanguageSelectBase
        open={openLanguage}
        HeaderComponent={
          <Button
            onClick={() => setOpenLanguage(!openLanguage)}
            data-color="appbar-dropdown-header"
            startIcon={<LanguageIcon />}
          >
            {languageText}
          </Button>
        }
        options={languageOptions.map((option) => ({
          ...option,
          Component: (
            <FlagOptionWrapper>
              <FlagIcon countryCode={option.countryCode as CountryCode} /> {option.label}
            </FlagOptionWrapper>
          ),
        }))}
        onSelect={changeLanguage}
        onToggle={() => setOpenLanguage(!openLanguage)}
      />
    );

  return (
    <SelectWrapper position={position}>
      <CustomHeaderSelect
        open={openLanguage}
        HeaderComponent={
          <IconButton
            onClick={() => setOpenLanguage(!openLanguage)}
            iconColor={color === 'white' ? '--white' : '--gray-80'}
          >
            <LanguageIcon />
          </IconButton>
        }
        options={languageOptions.map((option) => ({
          ...option,
          Component: (
            <FlagOptionWrapper>
              <FlagIcon countryCode={option.countryCode as CountryCode} /> {option.label}
            </FlagOptionWrapper>
          ),
        }))}
        onSelect={(lang) => changeLanguage(lang)}
        onToggle={() => setOpenLanguage(!openLanguage)}
      />
      {withText && (
        <Typography variant={'textM'} color={color === 'white' ? '--white' : '--gray-80'}>
          {languageText}
        </Typography>
      )}
    </SelectWrapper>
  );
};
